import { render, staticRenderFns } from "./materialsTable.vue?vue&type=template&id=f9737ef6&"
import script from "./materialsTable.vue?vue&type=script&lang=js&"
export * from "./materialsTable.vue?vue&type=script&lang=js&"
import style0 from "./materialsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports